<template>
      <div class="grid-x grid-margin-x">
        

        <div class="cell small-12">
            <label class="font-medium text-gray-800 w-40">
                {{ name }}
            </label>
        </div>
    
        <div class="cell small-6">
            <input
                type="email"
                v-model="emailValue"
                @input="handleEmailChange"
                placeholder="Enter email"
                class="flex-1 border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
        </div>
    </div>

  </template>
  
  <script setup>
  import { ref, watch, toRefs } from 'vue'
  
  const props = defineProps({
    name: String,
    email: String,
  })
  
  const emit = defineEmits(['update:email'])
  
  const { email } = toRefs(props)
  const emailValue = ref(email.value)
  
  watch(email, val => {
    emailValue.value = val
  })
  
  function handleEmailChange() {
    emit('update:email', emailValue.value)
  }
  </script>
  